import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';

const MetaInfoConfig = () => {

    const { metaInfo } = useSelector((state) => ({
        metaInfo: state.metaInformationListR.data,
    }));
    const [seoData, setSeo] = useState({});

    // Get code from url
    let params = window.location.pathname.substring(1);

    useEffect(() => {
        if (params == "") params = "home";
        if (params == "games") params = "hot-games";
        if (metaInfo && metaInfo.length > 0) {

            for (const itr of metaInfo) {
                let seo = {
                    title: itr.title,
                    keyword: itr.keyword,
                    description: itr.description,
                };
                if (itr?.menu?.code == params || itr?.url_slug == params) {
                    setSeo(seo);
                    break;
                } else if (itr?.menu?.code !== params || itr?.url_slug !== params) {
                    seo['title'] = 'test game site';
                    seo['keyword'] = '';
                    seo['description'] = 'Gaming application';
                    setSeo(seo);
                }
            }
        }
    }, [params]);
    return (
        <Helmet>
            <title>{seoData.title}</title>
            <meta name='keywords' content={seoData.keyword} />
            <meta name='description' content={seoData.description} />
            <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1"></meta>
        </Helmet>
    )
}

export default MetaInfoConfig
